
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dining/[city]",
      function () {
        return require("private-next-pages/dining/[city].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dining/[city]"])
      });
    }
  